var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDataList',{ref:"dataList",attrs:{"items":_vm.accOrders,"service":_vm.fetchAccOrders},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('AccOrderListHeader')]},proxy:true},{key:"default",fn:function({ item }){return [_c('AccOrderListItem',{attrs:{"acc-order":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }